import {
  TagDialogHover,
  TagDialogHoverProps,
} from '@components/TagDialog/TagDialogHover';
import { ITagRaw } from '@models/Tag.model';
import { TagListWithDelete } from '@pages/Products/components/OnBoardingModal/components/TagListWithDelete';
import { zIndexes } from '@styles/zindex/zindex';
import { PossibleTagsVal } from '../TagDialog.utils';

interface AssetSidebarTagDialogWithListProps<T extends unknown[]> {
  calcTagProps: TagDialogHoverProps<T>['calcTagProps'];
  tags: Exclude<PossibleTagsVal, ITagRaw[]>;
  disableDialog: TagDialogHoverProps<T>['disableDialog'];
}
export function AssetSidebarTagDialogWithList<T extends unknown[]>(
  props: AssetSidebarTagDialogWithListProps<T>,
) {
  const { disableDialog, ...rest } = props;
  return (
    <TagDialogHover
      hoverCardProps={{
        zIndex: zIndexes.indexOf('page-tooltip'),
      }}
      {...props}
    >
      <TagListWithDelete noWrap={!disableDialog} {...rest} />
    </TagDialogHover>
  );
}
